import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { NspUpgradeService } from '../../../publisher/src/publisher-ui/upgrade/nsp-upgrade.service';
import { FeatureEnablementService } from '../../services/feature-enablement.service';
import { HybridInterconnectService } from './hybrid-interconnect.service';
import {environment} from '../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import { HttpUtils } from 'common';

@Component({
    selector: 'hybrid-interconnect-embed',
    template: require('./hybrid-interconnect-embed.html'),
    styles: [require('./hybrid-interconnect-embed.scss')]
})
export class HybridInterconnectEmbed implements OnInit {

    private isSystemAdmin: boolean = false;
    private isEnterpriseAdmin: boolean = false;
    private isOrgAdmin: boolean = false;
    private cmpType: string = '';
    private sitePairingEnabled: boolean = false;
    private isSentinelManagementEnabled: boolean = false;
    private isEndpointTypeHcm: boolean = false;
    private isComputeProfileTabActive: boolean = false;
    private isInterconnectMeshTabActive: boolean = false;

    public ts: number;
    public urls = {};

    constructor(private featureEnablementService: FeatureEnablementService, private nspUpgradeService: NspUpgradeService,
        private authService: AuthService, private interconnectService: HybridInterconnectService,
        private sanitizer: DomSanitizer) {
            this.ts = environment.ts || new Date().getTime();
            this.urls = {
                computeProfile: this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/hybrid-interconnect-app/compute-zone-index.html?ts=${this.ts}`),
                serviceMesh: this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/hybrid-interconnect-app/service-zone-index.html?ts=${this.ts}`),
                networkProfile: this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/hybrid-interconnect-app/network-index.html?ts=${this.ts}`),
                sentinelManagement: this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/hybrid-interconnect-app/sentinel-management.html?ts=${this.ts}`)
            };
    }

    public ngOnInit() {
        if (!!this.authService.loggedInUserInfo &&
            this.authService.loggedInUserInfo.roles &&
            this.authService.loggedInUserInfo.roles.length > 0) {
            this.isSystemAdmin = this.authService.loggedInUserInfo.roles.indexOf('System Administrator') > -1 ? true : false;
            this.isEnterpriseAdmin = this.authService.loggedInUserInfo.roles.indexOf('Enterprise Administrator') > -1 ? true : false;
            this.isOrgAdmin = this.authService.loggedInUserInfo.roles.indexOf('Organization Administrator') > -1 ? true : false;
            this.cmpType = this.authService.VREALM_TYPE;
            this.nspUpgradeService.queryHcmInstances(
                () => {
                    setTimeout(() => {
                        const localEndpoint = this.authService.getLocalHcmEndpoint();
                        this.isEndpointTypeHcm = localEndpoint && localEndpoint.endpoint && localEndpoint.endpoint.endpointType === 'hcm';
                        this.featureEnablementService.getFeatureEnablement(localEndpoint.resourceId, {feature: 'PAIRING'}).subscribe((result:any) => {
                            if (result.errors && result.errors.length > 0) {
                                let errorMessage: string = '';
                                for (const error of result.errors) {
                                    errorMessage = errorMessage.concat(errorMessage, error.text);
                                    console.log(errorMessage);
                                }
                                console.error(JSON.stringify(errorMessage));
                            } else {
                                if (!!result && result.operations.length > 0) {
                                    this.sitePairingEnabled = true;
                                    console.log('Site Pairing UI is activated');
                                } else {
                                    console.log('Site Pairing UI is deactivated');
                                }
                            }
                        }, (error) => {
                            console.error('Error calling feature enablement API:', error);
                        });

                        this.featureEnablementService.getFeatureEnablement(localEndpoint.resourceId, {feature: 'MOBILITY_OsAssistedMigration'}).subscribe((result:any) => {
                            if (result.errors && result.errors.length > 0) {
                                let errorMessage: string = '';
                                for (const error of result.errors) {
                                    errorMessage = errorMessage.concat(errorMessage, error.text);
                                }
                                console.error(JSON.stringify(errorMessage));
                            } else {
                                if (!!result && result.operations.length > 0) {
                                    this.isSentinelManagementEnabled = true;
                                    console.log('Sentinel Management UI is activated');
                                } else {
                                    console.log('Sentinel Management UI is deactivated');
                                }
                            }
                        }, (error) => {
                            console.error('Error calling feature enablement API:', error);
                        });

                        this.interconnectService.getAllComputeProfiles(localEndpoint.resourceId).subscribe((result) => {
                            if (result && result.items && result.items.length > 0) {
                                this.isInterconnectMeshTabActive = true;
                                this.isComputeProfileTabActive = false;
                            } else {
                               this.isComputeProfileTabActive = true;
                               this.isInterconnectMeshTabActive = false;
                            }
                        }, (error) => {
                            console.error('Error calling get all Compute profiles API:', error);
                        });

                    }, 10);
                },
                null);
        } else {
            console.log('Hybrid Interconnect App Error: Unable to get Loggedin user details');
        }
        this.bindEvent(window, 'message', (event) => {
            if ( event.data === 'childWindowLoaded' ) {
                const iFrame = document.getElementById('networkProfileListing') as HTMLIFrameElement;
                const iframeDoc = iFrame.contentDocument || iFrame.contentWindow.document;
                if (  iframeDoc.readyState  === 'complete' || iframeDoc.readyState  === 'interactive') {
                    const body = {
                        orgId: this.authService.loggedInUserInfo.currentOrganization,
                        role: this.authService.loggedInUserInfo.roles,
                        cmpType: this.authService.VREALM_TYPE
                    };
                    iFrame.contentWindow.postMessage(JSON.stringify(body), window.location.origin);
                }
            } else if ( event.data === 'serviceMeshWindowLoaded' ) {
                const iFrame = document.getElementById('serviceMeshListing') as HTMLIFrameElement;
                const iframeDoc = iFrame.contentDocument || iFrame.contentWindow.document;
                if (  iframeDoc.readyState  === 'complete' || iframeDoc.readyState  === 'interactive') {
                    const body = {
                        isSystemAdmin: this.isSystemAdmin,
                    };
                    iFrame.contentWindow.postMessage(JSON.stringify(body), window.location.origin);
                }
            } else if ( event.data === 'childWindowLoaded:ComputeProfileHome' ) {
                const iFrame = document.getElementById('computeProfileListing') as HTMLIFrameElement;
                const iframeDoc = iFrame.contentDocument || iFrame.contentWindow.document;
                if (  iframeDoc.readyState  === 'complete' || iframeDoc.readyState  === 'interactive') {
                    const body = {
                        orgId: this.authService.loggedInUserInfo.currentOrganization,
                        role: this.authService.loggedInUserInfo.roles,
                        cmpType: this.authService.VREALM_TYPE
                    };
                    iFrame.contentWindow.postMessage(JSON.stringify(body), window.location.origin);
                }
            }
        });
    }

    private bindEvent(element, eventName, eventHandler) {
        if (element.addEventListener) {
            element.addEventListener(eventName, eventHandler.bind(this), false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + eventName, eventHandler.bind(this));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/hybrid-interconnect/hybrid-interconnect-embed.ts